export const TOOLS_ENDPOINTS = {
    GET_ALL: '/tools',
    CREATE: '/tools/create',
    GET_BY_ID: (id: string) => `/tools/${id}`,
    UPDATE: (id: string) => `/tools/${id}`,
    DELETE: (id: string) => `/tools/${id}`,
} as const;
